import { paged } from '../index';

export interface FindAssigneesResult {
  Items: Assignee[];
  Page: paged.Params;
}

export enum AvailabilityStatus {
  Available = 'Available',
  Unavailable = 'Unavailable',
}

export interface FindAssigneesInput extends Partial<paged.Params> {
  User?: string;
  Country?: string;
  AvailabilityStatus?: AvailabilityStatus;
}

export interface Assignee {
  User: string;
  Country: string;
  AvailabilityStatus: AvailabilityStatus;
  CreatedAt: string;
  UpdatedAt: string | null;
}

export interface UpdateAvailabilityInput {
  AvailabilityStatus: AvailabilityStatus;
}
